export default __webpack_public_path__ + "static/media/eye.417a93f3.svg";